import React, { useEffect, useState, useRef } from "react";
import SocialHead from "@/components/SEO/SocialHead";
import MoviesCategories from "@/components/navigation/MoviesCategories";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import { TourBannerHero } from "@/components/banners/TourBanner";
import MoviesCatalog from "@/components/movies/MoviesCatalog";
import PublicationsCatalog from "@/components/publications/PublicationsCatalog";
import { Tab } from "@headlessui/react";
import { Nav } from "@/components/navigation/Navbar";
import * as Text from "@/components/text";
import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import ScrollingCalendar from "@/components/navigation/ScrollingCalendar";
import OnsiteEvents from "@/components/event/OnsiteEvents";
import OnlineEvents, {
  OnlineEventsCalendar,
} from "@/components/event/OnlineEvents";
import TvTour from "@/components/event/TvTour";
import animateScrollTo from "animated-scroll-to";
import useWindowSize from "@/hooks/useWindowSize";
import { InView } from "react-intersection-observer";
import GiraDocumental from "./giraDocumentales";

import {
  motion,
  useScroll,
  useTransform,
  AnimatePresence,
} from "framer-motion";
import classNames from "classnames";

export default function Gira({
  seccion,
  sections,
  entries,
  fest,
  moviesBySection,
  entriesByCategory,
  categories,
  dataGira,
  isActiveGira,
}) {
  const [smallDiv, setSmallDiv] = useState(false);
  const [section, setSection] = useState(seccion || "tour");
  const [category, setCategory] = useState("");
  const [moviesCategory, setMoviesCategory] = useState("");
  const [publicationCategory, setPublicationCategory] = useState("");

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (section) {
      const s = {
        tour: "calendario",
        onlineTour: "gira-digital",
        movies: "las-peliculas",
        posts: "publicaciones",
        tvTour: "gira-television",
      }[section];

      // add section to query params

      const url = new URL(window.location.href);
      url.searchParams.set("seccion", s);
      window.history.replaceState({}, "", url);
    }
  }, [section]);

  useEffect(() => {
    let selectedIndex = {
      posts: 0,
      movies: 1,
      tvTour: 2,
      tour: isActiveGira.tv_tour ? 3 : 2,
      onlineTour:
        isActiveGira.tv_tour && isActiveGira.on_site_tour
          ? 4
          : (!isActiveGira.tv_tour && isActiveGira.on_site_tour) ||
            (isActiveGira.tv_tour && !isActiveGira.on_site_tour)
            ? 3
            : 2,
    }[section || "tour"];
    setActiveTab(selectedIndex);
  }, [section]);

  const headerRef = useRef(null);
  const navRef = useRef(null);
  const contentRef = useRef(null);
  const heroRef = useRef(null);

  // publications refs
  const programacionRef = useRef(null);
  const noticiasRef = useRef(null);
  const textosRef = useRef(null);
  const windowSize = useWindowSize();

  useEffect(() => {
    if (window && category) {
      document.getElementById(category).scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [category, smallDiv]);

  useEffect(() => {
    if (publicationCategory) {
      const r = document.getElementById(publicationCategory);
      animateScrollTo(r, {
        verticalOffset: smallDiv ? -300 : -550,
      });
    }
  }, [publicationCategory]);

  useEffect(() => {
    if (moviesCategory) {
      const r = document.getElementById(moviesCategory);
      animateScrollTo(r, {
        verticalOffset: smallDiv ? -300 : -550,
      });
    }
  }, [moviesCategory, windowSize.width]);

  useEffect(() => {
    if (isActiveGira && contentRef?.current) {
      if (smallDiv) {
        // document.body.style.paddingTop = "50px";
        contentRef.current.style.marginTop = 50 + "px";
      } else {
        // document.body.style.paddingTop = "0px";
        contentRef.current.style.marginTop = 0 + "px";
      }
    }
  }, [smallDiv]);

  const { scrollY } = useScroll({
    ref: contentRef,
  });

  useEffect(() => {
    scrollY.onChange((latest) => {
      if (latest > 65) {
        document.body.style.paddingTop = "100px";

        setSmallDiv(true);
      } else if (latest <= 65) {
        document.body.style.paddingTop = "0px";
        setSmallDiv(false);
      }
    });

    return () => {
      scrollY.destroy();
      document.body.style.paddingTop = "0px";
    };
  }, []);

  return (
    <div>
      <SocialHead title="Gira - Ambulante" description="Gira de documentales" />

      <InView
        initialInView={true}
      // onChange={(inView, entry) => setSmallDiv(!inView)}
      >
        <motion.div className="amb-container" ref={navRef}>
          <Nav theme="light" />
        </motion.div>
      </InView>

      {false && isActiveGira.active_tour && (
        <Tab.Group as="div" className="" selectedIndex={activeTab}>
          <div
            ref={headerRef}
            style={{
              width: "100%",
              top: 0,
              position: "sticky",
            }}
            className="z-50 "
          >
            <div ref={heroRef}>
              <TourBannerHero
                image={fest?.hero_image?.data?.attributes?.url}
                fromDate={fest?.start_date}
                toDate={fest?.end_date}
                title={fest?.name}
                description={fest?.description}
                videoUrl={fest?.promotional_video}
                simple={!smallDiv}
              />
            </div>
            <div className="">
              <Tab.List
                as="nav"
                className={classNames(
                  smallDiv ? " " : "border-b border-neutral-500",
                  "w-full bg-white "
                )}
              >
                <div className="amb-container flex gap-5 ">
                  <Flicking moveType="freeScroll" className="m-0" bound={true}>
                    <Tab
                      as="div"
                      onClick={() => setSection("posts")}
                      className={({ selected }) =>
                        classNames(
                          selected
                            ? "border-b-4 border-neutral-900"
                            : "border-b-4 border-transparent",
                          "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                        )
                      }
                    >
                      <Text.Label
                        size="lg"
                        className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                      >
                        Publicaciones
                      </Text.Label>
                    </Tab>

                    <Tab
                      as="div"
                      onClick={() => setSection("movies")}
                      className={({ selected }) =>
                        classNames(
                          selected
                            ? "border-b-4 border-neutral-900"
                            : "border-b-4 border-transparent",
                          "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900 "
                        )
                      }
                    >
                      <Text.Label
                        size="lg"
                        className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                      >
                        Las películas
                      </Text.Label>
                    </Tab>

                    {isActiveGira.tv_tour && (
                      <Tab
                        as="div"
                        onClick={() => setSection("tvTour")}
                        className={({ selected }) =>
                          classNames(
                            selected
                              ? "border-b-4 border-neutral-900"
                              : "border-b-4 border-transparent",
                            "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                          )
                        }
                      >
                        <Text.Label
                          size="lg"
                          className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                        >
                          En televisión
                        </Text.Label>
                      </Tab>
                    )}

                    {isActiveGira.on_site_tour && (
                      <Tab
                        as="div"
                        onClick={() => setSection("tour")}
                        className={({ selected }) =>
                          classNames(
                            selected
                              ? "border-b-4 border-neutral-900"
                              : "border-b-4 border-transparent",
                            "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                          )
                        }
                      >
                        <Text.Label
                          size="lg"
                          className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                        >
                          Calendario
                        </Text.Label>
                      </Tab>
                    )}

                    {isActiveGira.online_tour && (
                      <Tab
                        as="div"
                        onClick={() => setSection("onlineTour")}
                        className={({ selected }) =>
                          classNames(
                            selected
                              ? "border-b-4 border-neutral-900"
                              : "border-b-4 border-transparent",
                            "group  box-border  cursor-pointer p-5 hover:border-b-neutral-900"
                          )
                        }
                      >
                        <Text.Label
                          size="lg"
                          className="flex gap-x-3 text-neutral-500 group-hover:text-neutral-1000"
                        >
                          Gira en línea
                        </Text.Label>
                      </Tab>
                    )}
                  </Flicking>
                </div>
              </Tab.List>
              &nbsp;
              {smallDiv ? null : (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { delay: 0.2 } }}
                  exit={{ opacity: 0 }}
                  className="amb-container"
                >
                  {section === "apoyo" ? (
                    <div className="md:flex md:items-center">
                      <Text.Display className="grow" as="h2">
                        Apoyo
                      </Text.Display>
                      <Text.Body
                        className="max-w-screen-md text-neutral-400 md:text-right"
                        fontWeight="light"
                        size="xl"
                      >
                        Desde 2005 hemos trabajado para construir una sociedad
                        más crítica, empática, abierta y comprometida gracias al
                        apoyo de nuestros aliados.
                      </Text.Body>
                    </div>
                  ) : null}
                </motion.div>
              )}
              <div
                className={classNames(
                  smallDiv ? "mt-0 bg-neutral-50 py-4 " : "bg-white pt-16 ",
                  "  "
                )}
              >
                <div className="amb-container">
                  {section === "posts" ? (
                    <div className="space-y-6 ">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Publicaciones</Text.Display>
                      )}
                      <MoviesCategories
                        categories={categories?.map(
                          (entry) => entry.attributes.name
                        )}
                        selected={publicationCategory}
                        setSelected={setPublicationCategory}
                      />
                    </div>
                  ) : null}
                  {section === "movies" ? (
                    <div className="space-y-6 ">
                      <div className="space-y-3">
                        {smallDiv ? null : (
                          <motion.div
                            initial={{ opacity: 0, display: "block" }}
                            animate={{
                              opacity: 1,
                              transition: { delay: 0.2 },
                            }}
                            exit={{
                              opacity: 0,
                              display: "none",
                              transition: { delay: 0.2 },
                            }}
                          >
                            <Text.Display as="h2">Las películas</Text.Display>
                          </motion.div>
                        )}

                        {sections?.length > 0 ? (
                          <div className="">
                            <Text.Overline>SECCIONES:</Text.Overline>
                            <MoviesCategories
                              categories={sections.map(
                                (section) => section.name
                              )}
                              selected={category}
                              setSelected={setCategory}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ) : null}

                  {section === "tvTour" ? (
                    <div className="space-y-2">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Gira en televisión</Text.Display>
                      )}
                      <TvTour />
                    </div>
                  ) : null}

                  {section === "tour" ? (
                    <div className="space-y-6 ">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Calendario</Text.Display>
                      )}
                      <ScrollingCalendar />
                    </div>
                  ) : null}

                  {section === "onlineTour" ? (
                    <div className="space-y-6 ">
                      {smallDiv ? null : (
                        <Text.Display as="h2">Gira en línea</Text.Display>
                      )}
                      <OnlineEventsCalendar />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <Tab.Panels ref={contentRef}>
            <Tab.Panel>
              <div key={0} className="amb-container space-y-10 ">
                {categories?.length > 0
                  ? Object.keys(entriesByCategory).map((entry, i) => (
                    <PublicationsCatalog
                      id={entry}
                      key={i}
                      title={entry}
                      publications={entriesByCategory[entry]}
                    />
                  ))
                  : null}
              </div>
            </Tab.Panel>

            <Tab.Panel>
              <div key={0} className="amb-container">
                {sections?.length > 0
                  ? sections.map((section, i) => (
                    <MoviesCatalog
                      key={i}
                      id={section.name}
                      movies={moviesBySection[section.slug]}
                      title={section.name}
                      description={section?.description || ""}
                    />
                  ))
                  : null}
              </div>
            </Tab.Panel>

            <div className="amb-container">
              {section === "tour" ? <OnsiteEvents /> : null}
            </div>

            <div className="amb-container">
              {section === "onlineTour" ? <OnlineEvents /> : null}
            </div>
          </Tab.Panels>
        </Tab.Group>
      )}
      {true && <GiraDocumental dataGira={dataGira} />}
    </div>
  );
}

export async function getServerSideProps({ query }) {
  try {
    const activeGira = await apiClient.get(`/api/configuracion-global`);
    const isActiveGira = {
      on_site_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR ||
        activeGira.data.data.attributes.on_site_tour,
      online_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR ||
        activeGira.data.data.attributes.online_tour,
      tv_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR ||
        activeGira.data.data.attributes.tv_tour,
      active_tour:
        process.env.NEXT_PUBLIC_IS_ACTIVE_TOUR ||
        activeGira.data.data.attributes.active_tour,
    };
    const populateTourYear = qs.stringify({
      populate: {
        ediciones_gira: {
          populate: "*",
        },
      },
    });
    const tourYear = await apiClient.get(`/api/tour?${populateTourYear}`);

    const seccion = {
      calendario: isActiveGira.on_site_tour ? "tour" : null,
      "gira-digital": isActiveGira.online_tour ? "onlineTour" : null,
      "gira-television": isActiveGira.tv_tour ? "tvTour" : null,
      "las-peliculas": "movies",
      publicaciones: "posts",
    }[query?.seccion || "las-peliculas"];

    if (false) {
      const populateFest = qs.stringify({
        populate: {
          entradas: {
            populate: "*",
            publicationState: "live",
          },
          hero_image: {
            populate: "*",
          },
        },
        filters: {
          name: {
            $eq: tourYear.data.data.attributes.ediciones_gira.data[0].attributes
              .name,
          },
        },
      });
      const fest = await apiClient.get(`api/ediciones-gira?${populateFest}`);

      const movies = await apiClient.get(
        `api/films?${qs.stringify({
          populate: {
            Directores: "*",
            film_year: "*",
            countries: "*",
            film_cover_image: "*",
            secciones: "*",
          },
          filters: {
            ediciones_giras: {
              name: {
                $eq: tourYear.data.data.attributes.ediciones_gira.data[0]
                  .attributes.name,
              },
            },
          },
          pagination: {
            pageSize: 150,
          },
        })}`
      );

      let moviesBySection = {};
      let sectionsIdArray = [];

      if (movies.data.data.length > 0) {
        moviesBySection = movies.data.data.reduce((acc, movie) => {
          const section = movie?.attributes.secciones.data[0]?.attributes.slug;
          if (acc[section]) {
            acc[section].push(movie);
          } else {
            acc[section] = [movie];
          }
          return acc;
        }, {});

        sectionsIdArray = Object.keys(moviesBySection).map((section) => {
          return moviesBySection[section][0]?.attributes.secciones.data[0]?.id;
        });
      }

      const q = qs.stringify({
        filters: {
          id: {
            $in: sectionsIdArray,
          },
        },
      });
      const sectionsRequest = await apiClient.get(`api/sections?${q}`);
      const sections = sectionsRequest.data.data.map((section) => {
        return section.attributes;
      });

      const entriesByCategory =
        fest.data.data[0].attributes.entradas.data.reduce((acc, entry) => {
          if (!entry.attributes?.categorias?.data[0]?.attributes?.slug) {
            // assign to "otros" category
            if (acc["Otros"]) {
              acc["Otros"].push(entry);
            } else {
              acc["Otros"] = [entry];
            }
            return acc;
          }
          const category = entry.attributes.categorias.data[0].attributes.name;
          if (acc[category]) {
            acc[category].push(entry);
          } else {
            acc[category] = [entry];
          }
          return acc;
        }, {});

      const categoriesIdArray = Object.keys(entriesByCategory).map(
        (category) => {
          if (category === "Otros") {
            return null;
          }
          return entriesByCategory[category][0].attributes.categorias.data[0]
            .id;
        }
      );

      const entryCategoriesRequest = await apiClient.get(
        `api/categories?${qs.stringify({
          populate: {
            entradas: {
              populate: "*",
            },
          },
          filters: {
            id: {
              $in: categoriesIdArray.filter((id) => id),
            },
          },
        })}`
      );

      const categories = entryCategoriesRequest.data.data;

      categories.push({
        attributes: {
          name: "Otros",
          slug: "otros",
        },
      });

      return {
        props: {
          seccion: seccion || "",
          sections,
          categories: entryCategoriesRequest.data.data,
          entriesByCategory,
          fest: fest.data.data[0].attributes,
          moviesBySection,
          isActiveGira: isActiveGira,
        },
      };
    } else {
      const queryGira = qs.stringify({
        populate: {
          headertitle: "*",
          peliculas: {
            populate: {
              film_cover_image: "*",
              Directores: "*",
              film_year: "*",
              countries: "*",
              iniciativas: "*",
            },
          },
          quotes: "*",
          edicion: {
            populate: {
              title: "*",
              subtitle: "*",
              description: "*",
              download_urls: "*",
              header: "*",
              preview_image: "*",
              media: {
                populate: {
                  image: "*",
                  title: "*",
                  description: "*",
                },
              },
              media2: {
                populate: {
                  image: "*",
                  title: "*",
                  description: "*",
                },
              },
            },
          },
        },
      });
      const dataGira = await apiClient.get(`/api/gira-inactiva?${queryGira}`);
      return {
        props: {
          dataGira: dataGira.data.data.attributes,
          isActiveGira: isActiveGira,
        },
      };
    }
  } catch (err) {
    return {
      props: {
        notFound: true,
      },
    };
  }
}
